
import React, { useEffect, useState, useRef } from 'react'
import { useNavigate } from "react-router";
import { LoginCheck } from "./Fetch/Login";
import { addFactura } from "./Fetch/FindFacturas";
export default function AddFactura() {
    const refi = useRef();
    const [data, setData] = useState({
        show: false,
        loading: false,
        error: '',
        data: { desc: '', pdf: '', xml: '' }
    })
    let navigate = useNavigate();

    useEffect(() => {

        if (localStorage.getItem("ContaKMP")) {

            LoginCheck(localStorage.getItem("ContaKMP")).then(res => {

                if (res === '') {
                    localStorage.removeItem("ContaKMP");
                    navigate("/");
                } else {
                    localStorage.setItem("ContaKMP", res);
                    setData(v => ({
                        ...v,
                        show: true
                    }))
                }

            }).catch(e => {
                console.log(e)
            })
        } else {
            navigate("/");
        }
    }, [navigate])

    const addF = (e, text) => {
        e.preventDefault();
        var file = e.target.files[0];
        if (file) {
            if ((text === 'pdf' && file.type === 'application/pdf') || (text === 'xml' && file.type === 'text/xml')) {
                setData({
                    ...data,
                    error: "",
                    data: {
                        ...data.data,
                        [text]: file
                    }
                })

            } else {
                setData(v => ({
                    ...v,
                    error: `El archivo ingresado no es un archivo de extension .${text}`,
                    data: {
                        ...data.data,
                        [text]: ''
                    }
                }))
                refi.current.reset();
            }
        } else {
            setData(v => ({
                ...v,
                error: "El archivo ingresado es nulo"
            }))
        }
    }

    const Guardar = (e) => {
        e.preventDefault();
        Checking();

        addFactura(data.data).then(res => {
            if (res.Lado === "Ejecucion") {
                navigate("/FindFactura");
            } else {
                setData(v => ({
                    ...v,
                    loading: false,
                    error: res.mensaje
                }))
                refi.current.reset();
            }
        }).catch(err =>
            console.log(err)
        )
    }

    const Checking = () => {
        setData(v => ({
            ...v,
            loading: true,
            error: ''
        }))
    }

    return (
        data.show === false ?
            <div>Loading...</div>
            :
            <form ref={refi} onSubmit={Guardar}>
                <table border={1}>
                    <thead>
                        <tr>
                            <td>Cargar Factura</td>

                            <td><button onClick={(e) => {
                                e.preventDefault();
                                navigate("/FindFactura");
                            }}>Buscador</button></td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Descripción</td>
                            <td><input required disabled={data.loading} type='text' placeholder='Descripción' minLength={5} size="50" onChange={(e) => {
                                e.preventDefault();
                                setData({
                                    ...data,
                                    data: {
                                        ...data.data,
                                        desc: e.target.value
                                    }
                                })
                            }
                            } /></td>
                        </tr>
                        <tr>
                            <td colSpan={2}><p></p></td>
                        </tr>
                        <tr>
                            <td>pdf</td>
                            <td><input required disabled={data.loading} type='file' accept=".pdf" placeholder='pdf' onChange={(e) => { addF(e, 'pdf') }} /></td>
                        </tr>
                        <tr>
                            <td colSpan={2}><p></p></td>
                        </tr>
                        <tr>
                            <td>xml</td>
                            <td><input required disabled={data.loading} type='file' accept=".xml" placeholder='xml' onChange={(e) => { addF(e, 'xml') }} /></td>
                        </tr>
                        <tr>
                            <td colSpan={2}><button disabled={data.loading} type='submit'>Cargar</button></td>
                        </tr>
                        {
                            data.error ?
                                <tr>


                                    <td colSpan={2}>
                                        <table border={1}>
                                            <tr>
                                                <td>Codigo Error SQL</td>
                                                <td>{data.error.errorInfo[0]}</td>
                                            </tr>
                                            <tr>
                                                <td>Codigo Error Driver</td>
                                                <td>{data.error.errorInfo[1]}</td>
                                            </tr>
                                            <tr>
                                                <td>Mensaje</td>
                                                <td>{data.error.errorInfo[2]}</td>
                                            </tr>
                                        </table>
                                    </td>

                                </tr>
                                :
                                ''
                        }
                    </tbody>
                </table>
            </form>

    )
}
